export class apiClientService {
  /* @ngInject */
  constructor(appSettings, $http, $window) {
    this.appSettings = appSettings;
    this.$http = $http;
    this.$window = $window;
  }
  async get(uri) {
    const endpoint = this.getApiUrl() + uri;
    const result = await this.$http.get(endpoint, { headers: this.headers });
    return result.data;
  }
  async post(uri, postData) {
    const endpoint = this.getApiUrl() + uri;
    const result = await this.$http.post(endpoint, postData, {
      headers: this.headers,
    });
    return result.data;
  }
  async ssoPost(uri, postData) {
    const endpoint = this.getSsoUrl() + uri;
    const result = await this.$http.post(endpoint, postData, {
      headers: this.headers,
    });
    return result.data;
  }
  async put(uri, postData) {
    const endpoint = this.getApiUrl() + uri;
    const result = await this.$http.put(endpoint, postData, {
      headers: this.headers,
    });
    return result.data;
  }
  getSsoUrl() {
    if (!this.apiUrl) this.setApiUrl();
    return this.apiUrl + "/ssoapi";
  }
  getApiUrl() {
    if (!this.apiUrl) this.setApiUrl();
    return this.apiUrl + this.appSettings.apiPath;
  }
  setApiUrl() {
    const host = this.$window.location.host;
    console.log("host is: " + host);

    if (host.includes("localhost")) this.isLocal = true;

    if (this.isLocal && this.appSettings.localhostApi == "local")
      this.apiUrl = this.appSettings.devApis.localhost;
    if (
      host.includes("-dev") ||
      (this.isLocal && this.appSettings.localhostApi == "dev")
    )
      this.apiUrl = this.appSettings.devApis.dev;
    else if (
      host.includes("-test") ||
      (this.isLocal && this.appSettings.localhostApi == "test")
    )
      this.apiUrl = this.appSettings.devApis.test;
    else if (
      host.includes("-staging") ||
      (this.isLocal && this.appSettings.localhostApi == "staging")
    )
      this.apiUrl = this.appSettings.devApis.staging;

    if (!this.apiUrl) this.apiUrl = this.appSettings.api;

    console.log("api is: " + this.apiUrl);
  }
  setTokenAuthHeader(token, accountCountry) {
    this.headers = {
      "Clio-Auth-Token": token,
      "x-account-country": accountCountry
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/apiClient.service.js